module.exports = __webpack_public_path__ + "img/traveler.99247f78.webp";